export const uniq = (arr: string[]) => {
  const map = new Map();
  return arr.filter((item) => {
    return !map.has(item) && map.set(item, 1);
  });
}
